import {
  IonIcon,
} from '@ionic/react';

import CrossIcon from '@/assets/icons/cross.svg';
import LoginError from '@/pages/Login/LoginError/LoginError';

import styles from './LoginErrorModal.module.scss';

export interface LoginErrorModalProps {
  onDismiss: () => void;
  removeSubtitle?: boolean;
}

export default function LoginErrorModal({
  onDismiss,
  removeSubtitle,
}: LoginErrorModalProps) {
  return (
    <div id="bottom-modal-login-error" className={styles.container}>
      <div className={styles.closeButton}>
        <IonIcon
          id="button-close-setup-biometry-modal"
          src={CrossIcon}
          onClick={() => onDismiss()}
        />
      </div>
      <LoginError hideHeader removeSubtitle={removeSubtitle} close={() => onDismiss()} />
    </div>
  );
}
